export default __webpack_public_path__ + "static/banner-tampons-2-9d4fc82cbb8692e4040fb88a59d1aedf.png";